module.exports = __webpack_public_path__ + "img/constructor-white.efb3b56f.svg";